import { useState } from 'react';
import { message } from 'antd';
import { useSubCategoryTipStatistics } from '../../../../../../hooks/api/subCategoryTip';
import {
  DefaultFetchError,
  getMessageInError,
} from '../../../../../../hooks/fetch';

export const useTipStatistic = () => {
  const subCategoryTipStatistics = useSubCategoryTipStatistics();

  const [responseWithId, setResponseWithId] = useState<{
    data: any;
    subCategoryId: string;
  } | null>(null);

  const getTipStatistic = (subCategoryId: string) => {
    subCategoryTipStatistics
      .fetch(undefined, `${subCategoryId}/tips-statistics`)
      .then((response) => {
        if (response) {
          setResponseWithId({
            data: response,
            subCategoryId,
          });
        }
      })
      .catch((error: DefaultFetchError) => {
        message.error(getMessageInError(error));
      });
  };

  return {
    getTipStatistic,
    response: responseWithId,
    loading: subCategoryTipStatistics.loading,
    error: subCategoryTipStatistics.error,
  };
};
